import { WebsiteComponentEnum, WebsitePathNameEnum } from '../../../../../shared/enums';
import { RouteInfo } from '../../../../../shared/models/countryConfig';

export const findComponentByName: (name: WebsitePathNameEnum | string, routes: RouteInfo[]) => WebsiteComponentEnum = (
  name: string,
  routes: RouteInfo[]
): WebsiteComponentEnum => routes.find((route: RouteInfo): boolean => route.name === name)?.component || WebsiteComponentEnum.Website;
